import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminSponsorsPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", url: "", contact_email: "", notes: "" });
  const upd = (k, v) => setForm(s => ({ ...s, [k]: v }));
  const load = () => api.get("/admin/sponsors").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);
  const add = async () => {
    try { await api.post("/admin/sponsors", form); toast.success("Added"); setForm({name:"",url:"",contact_email:"",notes:""}); load(); }
    catch { toast.error("Add failed"); }
  };
  const remove = async (id) => { if (!confirm("Delete sponsor?")) return; await api.delete(`/admin/sponsors/${id}`); load(); };
  return (
    <AdminLayout>
      <div className="kicker">Optional</div>
      <h1 className="mt-1 font-serif text-3xl font-semibold">Sponsors</h1>
      <p className="mt-2 text-sm text-muted-foreground">Manage sponsors and disclosure labels. Sponsored placements are always clearly labeled.</p>

      <Card className="mt-6 p-6">
        <div className="kicker">Add sponsor</div>
        <div className="mt-3 grid gap-3 md:grid-cols-2">
          <Input placeholder="Name" value={form.name} onChange={e => upd("name", e.target.value)} className="h-11" />
          <Input placeholder="URL" value={form.url} onChange={e => upd("url", e.target.value)} className="h-11" />
          <Input placeholder="Contact email" value={form.contact_email} onChange={e => upd("contact_email", e.target.value)} className="h-11" />
          <Input placeholder="Disclosure label" defaultValue="Sponsored" onChange={e => upd("disclosure_label", e.target.value)} className="h-11" />
          <Textarea placeholder="Notes" value={form.notes} onChange={e => upd("notes", e.target.value)} rows={2} className="md:col-span-2" />
        </div>
        <div className="mt-3"><Button onClick={add} className="bg-[color:var(--coh-ink)] text-white">Add</Button></div>
      </Card>

      <Card className="mt-4 p-0 overflow-hidden">
        <table className="w-full text-sm admin-table">
          <thead className="bg-secondary border-b border-border"><tr><th className="px-4 py-3 text-left">Name</th><th className="px-4 py-3 text-left">URL</th><th className="px-4 py-3 text-left">Active</th><th /></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={4} className="px-4 py-6 text-center text-muted-foreground">No sponsors yet.</td></tr>}
            {items.map((s) => (
              <tr key={s.id} className="border-b border-border last:border-b-0">
                <td className="px-4 py-3">{s.name}</td>
                <td className="px-4 py-3 text-xs">{s.url}</td>
                <td className="px-4 py-3">{s.active ? "Yes" : "No"}</td>
                <td className="px-4 py-3 text-right"><Button size="sm" variant="ghost" onClick={() => remove(s.id)}>Delete</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </AdminLayout>
  );
}
